import React from "react"
import { withPrefix } from "gatsby"
import Image from "../components/image"
import memberVoicesData from "../data/member_voices.json"
import AudioPlayer from "../components/audio-player"

export default function MemberVoices({ id }) {
  const data = memberVoicesData.find(obj => {
    return obj.id === id
  })

  return (
    <section
      className={
        data.bgColor
          ? "member-voices theme-bg-color--" + data.bgColor
          : "member-voices"
      }
    >
      <header>
        <Image
          path={data.image}
          alt={data.name}
          className="member-voices__portrait"
        />
        <div>
          <h3>Member Voices</h3>
          <h4>The New Unknown</h4>
        </div>
      </header>
      <div className="member-voices__quote">{data.quote}”</div>
      <footer>
        <div>
          <h5>{data.name}</h5>
          <p>{data.title}</p>
        </div>
        {data.audio ? (
          <AudioPlayer file={withPrefix("/") + data.audio} />
        ) : null}
      </footer>
    </section>
  )
}
